import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function PlanSelector() {
  return (
    <section className={cn(theme.cards.base, "p-6")}>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Change Plan</h2>
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Email{" "}
        <a
          href="mailto:quiet.lens2873@fastmail.com"
          className={cn("font-semibold hover:underline", theme.text.primaryOrange)}
        >
          quiet.lens2873@fastmail.com
        </a>{" "}
        to change your plan.
      </p>
    </section>
  );
}
